// extracted by mini-css-extract-plugin
export default {"content":"HomeCard_content__oI3+Q","inset":"HomeCard_inset__OQN6s","section":"HomeCard_section__xJDPh","highAttentionLevel":"HomeCard_highAttentionLevel__ogHT+"};